import('./app').then(app => app.init())
